import React from "react"

interface IButtonProps {
    title: string,
    btnClassName?: string,
    isLoading?: boolean,
    isPrimary?: boolean,
    btnType?: any,
}

const Button: React.FC<IButtonProps> = ({title, btnClassName = "", btnType = "submit", isLoading = false, isPrimary=true}) => {
    return (
        <button type={btnType}
                className={`${isLoading ? "bg-gray-400" : (isPrimary ? "bg-primary" : "bg-secondary")} px-4 py-4 rounded-xl opacity-100 text-white cursor-pointer  transition duration-200 hover:opacity-60 ${btnClassName ?? ""}`}
                disabled={isLoading}>
            <div className={"flex justify-center items-center"}>
                {isLoading && <div>
                    <svg className="animate-spin -ml-1 ml-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                         viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                        <path className="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                    </svg>
                </div>}
                <div className={"text-lg"}>{title}</div>
            </div>
        </button>
    )
}

export default Button